import type { Translations } from './zh';

export const ja: Translations = {
  bubble: {
    open: 'チャットを開く',
    close: 'チャットを閉じる',
    badge: 'オンライン',
    dragHint: '長押しで移動できます',
  },
  panel: {
    closeAria: 'チャットパネルを閉じる',
    languageAria: '言語を選択',
    welcomeFallback: 'こんにちは、ご用件をお伺いします。',
    quickQuestionsTitle: '以下の質問を試してみてください',
    quickAskTitle: 'クイック質問',
    inputPlaceholder: 'ご質問を入力してください...',
    sendButton: '送信',
    sendAria: 'メッセージを送信',
    onlineStatus: 'オンライン',
    thinkingAria: '考え中',
    aiBusyHint: 'ただいま回答中です。しばらくお待ちください…',
    leadReopenHint: '必要なときに、ここから連絡先をお知らせください',
    startChat: '今すぐ相談',
    welcomeQuickHint: 'クイックガイド',
    videoPreparing: '映像を準備中です…',
    newMessageTitle: '💬 新着メッセージ',
    newMessageBody: '新しいメッセージが届きました。クリックして確認してください。',
  },
  roles: {
    visitor: 'お客様',
    ai: 'AIアシスタント',
    human: 'オペレーター',
    system: 'システム',
  },
  web: {
    aiChat: 'AIサポート',
    humanChat: '有人対応',
    switchToHuman: '有人対応へ',
    switchToAI: 'AIに戻る',
    resetChat: 'リセット',
    commonQuestions: 'よくある質問',
    faqTitle: 'よくある質問と回答',
    selectLanguage: '言語選択',
    maximize: '最大化',
    restore: '元に戻す',
    offlineLabel: 'オフライン',
    aiGreeting: 'こんにちは!AIアシスタントです。どのようなご用件でしょうか?',
    humanGreeting: 'こんにちは、担当者におつなぎしました。ご用件をお伺いします。',
    agentOffline: 'オフライン',
    agentOfflineMessage: '申し訳ございません。担当者は現在オフラインです。下記のQRコードをスキャンしてWeChatでご連絡ください。',
    wechatPrompt: 'WeChatを追加',
    wechatHint: 'WeChatでスキャンして担当者を追加',
    serviceHoursLabel: '対応時間: ',
    viewImage: '画像を表示',
    playVideo: '動画を再生',
    closeViewer: '閉じる',
    downloadFile: 'ダウンロード',
    fileTypePdf: 'PDF ドキュメント',
    fileTypeWord: 'Word 文書',
    fileTypeExcel: 'Excel スプレッドシート',
    fileTypePpt: 'PowerPoint プレゼンテーション',
    fileTypeArchive: '圧縮ファイル',
    fileTypeGeneric: 'ファイル',
  },
  leadCard: {
    ariaForm: '連絡先フォーム',
    title: '連絡先をご記入ください',
    nameLabel: 'お名前',
    namePlaceholder: 'お名前を入力してください',
    phoneLabel: '電話番号',
    phonePlaceholder: '電話番号を入力してください',
    phoneError: '正しい電話番号を入力してください',
    submit: '送信',
    submitting: '送信中…',
    dismiss: '後で',
    success: 'ありがとうございます。担当者より折り返しご連絡いたします。',
  },
};
